// @flow

export default class POSType {

  static POS_DEMO = '';

  static POS_CASHPAD = 'cashpad';

  static POS_CSI = 'csi';

  static POS_IKENTOO = 'ikentoo';

  static POS_ORCHESTRA = 'orchestra';

  static POS_ORCHESTRA_V2 = 'orchestra-v2';

  static POS_PAYMYTABLE = 'paymytable';

  static POS_TILLER = 'tiller';

  static POS_TCPOS = 'tcpos';
  static POS_TCPOS_7_1 = 'tcpos7.1';
  static POS_TCPOS_7_4 = 'tcpos7.4';

  static POS_ZELTY = 'zelty';

  static POS_SEQUOIASOFT = 'sequoiasoft';

  static POS_ORACLE = 'oracle';

  /**
   * @return array
   */
  static getChoices(): Array<Object> {
    return [
      {
        label: 'Demo',
        value: POSType.POS_DEMO
      },
      {
        label: 'Cashpad',
        value: POSType.POS_CASHPAD
      },
      {
        label: 'CSI - CashSystemes',
        value: POSType.POS_CSI
      },
      {
        label: 'Ikentoo',
        value: POSType.POS_IKENTOO
      },
      {
        label: 'Oracle',
        value: POSType.POS_ORACLE
      },
      {
        label: 'Orchestra',
        value: POSType.POS_ORCHESTRA
      },
      {
        label: 'Orchestra v2',
        value: POSType.POS_ORCHESTRA_V2
      },
      {
        label: 'PayMyTable',
        value: POSType.POS_PAYMYTABLE
      },
      {
        label: 'SequoiaSoft',
        value: POSType.POS_SEQUOIASOFT
      },
      {
        label: 'Tiller',
        value: POSType.POS_TILLER
      },
      {
        label: 'Tcpos',
        value: POSType.POS_TCPOS
      },
      {
        label: 'Tcpos 7.1',
        value: POSType.POS_TCPOS_7_1
      },
      {
        label: 'Tcpos 7.4',
        value: POSType.POS_TCPOS_7_4
      },
      {
        label: 'Zely',
        value: POSType.POS_ZELTY
      }
    ];
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/constants/POSType.js